import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-fields/abstract-value-accessor/abstract-value';
import { makeProvider } from '@shared/form-fields/make-provider';
import type { FixedRateOwner } from '@shared/modules/fixed-rates/fixed-rate';
import type { HasDefaultRateStrategy } from '../../contract-option-sets/contract-option-sets';

@Component({
    selector: 'app-fixed-rates-card',
    templateUrl: './fixed-rates-card.component.html',
    providers: [makeProvider(FixedRatesCardComponent)],
})
export class FixedRatesCardComponent extends AbstractInputComponent<any> {
    @Input() override = false;
    @Output() overrideChange = new EventEmitter<boolean>();

    @Input() showOverrideButton = false;

    @Input() parent: FixedRateOwner & HasDefaultRateStrategy;
    @Input() owner: FixedRateOwner & HasDefaultRateStrategy;

    get isDisabled() {
        return super.disabled || (this.showOverrideButton && !this.override);
    }

    get activeOwner() {
        if (this.showOverrideButton && !this.override) {
            return this.parent;
        }

        return this.owner;
    }

    set activeOwner(value) {
        if (this.showOverrideButton && !this.override) {
            this.parent = value;
        } else {
            this.owner = value;
        }
    }

    get overridden() {
        return this.override;
    }

    set overridden(value) {
        this.override = value;
        this.overrideChange.emit(this.override);
    }
}
